///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { set, forEach } = require("lodash");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.strategic_account = abcsetup.dashboard.strategic_account || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.strategic_account = {
    init: function () {
        // Cheap hack to add strategic_account specific dashboard styles
        $('body').addClass('strategic_account');
        //

        // $(document).on('click', '.btn-delete', function (e) {
        //     var _this = $(this);
        //     abcsetup.alerts.confirm('Delete Humana Spreadsheet', 'Are you sure you want to delete this Spreadsheet?', function (resp) {
        //         if (resp) {
        //             abcsetup.dashboard.strategic_account.delete(_this.data('id'),_this);
        //         }
        //     });
        // });

        //this.load_item_spreadsheet();
        //this.rfp.init();
        this.ncm.init();
        //this.show_import_progress();
    },

    /**
     * Loads the humana spreadsheet
     */
    load_item_spreadsheet() {

        const $item_spreadsheet_panel = $('#item_spreadsheet_panel');
        abcsetup.dashboard.showLoading($item_spreadsheet_panel);
        $item_spreadsheet_panel.find('#item_spreadsheets table, #item_spreadsheets .dataTables_wrapper').remove();

        axios.get('/api/humana/item_spreadsheet').then(response => {
            if (response.data.table_data) {
                $item_spreadsheet_panel.find('#item_spreadsheets table, #item_spreadsheets .dataTables_wrapper').remove();
                $item_spreadsheet_panel.find('#item_spreadsheets').append(response.data.table_data);

                // Init datatables
                abcsetup.datatables.init($item_spreadsheet_panel.find('#item_spreadsheets').find('#' + response.data.table_id), {
                    bInfo: true,
                    lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                    iDisplayLength: 10,
                    order: [[3, 'asc']],
                    language: {
                        'emptyTable': 'No spreadsheet found'
                    },
                });

                // Apply tooltips to the datatable
                const headers = $item_spreadsheet_panel.find('#item_spreadsheets').find('#' + response.data.table_id + ' th');
                headers.eq(2).attr('title', 'Bid start date');
                headers.eq(3).attr('title', 'Bid close date');
            }

            abcsetup.dashboard.removeLoading($item_spreadsheet_panel);

        }).catch(() => abcsetup.dashboard.removeLoading($item_spreadsheet_panel));

    },

    /**
     * Map of import progress ids to spreadsheet ids
     */
    import_progress_map: {},

    /**
     * Show item import progress
     */
    show_import_progress() {
        const _this = this;
        const in_progress_files = $("#app_data_tables_consumer_r_f_p_humana_spreadsheet_table .import_status");

        // First check if the table is loaded, if not check back every 5 seconds
        if (!in_progress_files[0]) {
            setTimeout(() => {
                abcsetup.dashboard.strategic_account.show_import_progress();
            }, 2000);
        }

        // Loop through files to populate map
        // The statuses within the map will populate only after the axios call completes allowing use to check multiple files with one call
        in_progress_files.each(function() {
            _this.import_progress_map[$(this).data("id")] = null;
        });

        // Loop through again and make axios calls
        in_progress_files.each(function() {
            const status_element = $(this);
            const id = status_element.data("id");
            const status = status_element.data("status");

            if (!id || !status) {
                //console.log('poll_import_item: invalid id/status');
                return;
            }

            if (status != 'error' && status != 'done') {
                axios.get("/api/humana/item_match_status/"+id).then(result => {
                    // No items match for spreadsheet
                    if ((Object.keys(result.data).length < 1)) {
                        //console.log('undefined->');
                        status_element.find('.items_progress').remove();
                        status_element.html(`
                            <div class="alert alert-danger mb-1 mt-1 ml-4 mr-4" role="alert">
                                An error has occured
                            </div>
                        `);
                        //console.error('result.data.status is not defined');
                        return;
                    }

                    // completed
                    if (result.data.status && result.data.status != 'in_progress') {
                        status_element.find('.items_progress').remove();
                        status_element.html(
                            `
                                <div class="d-flex align-items-center mb-1 mt-1 ml-4 mr-4 alert alert-info">
                                    <strong>Matching Completed</strong>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Success</td><td>:</td><td>${result.data.done != null ? result.data.done : 0}</td>
                                                <td>Failed</td><td>:</td><td>${result.data.failed != null ? result.data.failed : 0}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            `
                        );
                    }

                    // Update dom
                    status_element.attr("data-status",result.data.status);

                    // Set status and check our overall progress
                    _this.import_progress_map[id] = result.data.status;
                    _this.check_show_import_progress();

                });
            } else {
                _this.import_progress_map[id] = status;
            }
        });
    },

    /**
     *
     */
    check_show_import_progress() {

        const _this = this;
        let run_complete = true;
        let in_progress = false;

        for (const [key, value] of Object.entries(this.import_progress_map)) {
            if (value === null) {
                run_complete = false;
            }

            if (value === 'in_progress') {
                in_progress = true;
            }
        }

        if (run_complete && in_progress) {
            setTimeout(() => {
                //console.log('File import status: ' + JSON.stringify(_this.import_progress_map));
                _this.show_import_progress();
            }, 5000);

        }

    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFP Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfp: {
        init() {
            // TODO Working around the responsive plug-in not working right now.
            $('#rfp_outstanding,#rfp_in_review,#rfp_unsolicited_in_review,#rfp_library').find('.datatable').css('min-width', '100%');

            const inReviewToggle = $('.bhoechie-tab-content:has(#rfp_in_review) .btn-group-toggle');
            inReviewToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#rfp_in_review) .in_review_table`).hide();
                $(`.bhoechie-tab-content:has(#rfp_in_review) .${event.target.value}_table`).show();
            });

            $('#rfp_in_review .pending_samples_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_samples]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_in_review .pending_review_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_review]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_in_review .pending_other_user_review_table .datatable').on('xhr.dt', (event, settings, json) => {
                const badge = inReviewToggle.find('label:has(input[value=pending_other_user_review]) .badge');

                if (json.recordsTotal > 0) {
                    badge.show().text(json.recordsTotal);
                } else {
                    badge.hide();
                }
            });

            $('#rfp_unsolicited_in_review_badge .datatable').on('xhr.dt', (event, settings, json) => {
                abcsetup.dashboard.setBadge($('#rfp_unsolicited_in_review_badge'), json.recordsTotal);
            });

            $(document).on('click', '.humana_upload_update', function () {
                var id = $(this).data('id');
                var form = $(this).data('form');

                $('#'+form)[0].checkValidity();

                if($('#'+form)[0].checkValidity()) {
                    var bodyFormData = new FormData();
                    bodyFormData.append('start_date', $('#start_date_'+id).val());
                    bodyFormData.append('close_date', $('#close_date_'+id).val());
                    bodyFormData.append('usage_time_frame', $('#usage_time_frame_'+id).val());
                    bodyFormData.append('arrival_date', $('#arrival_date_'+id).val());
                    bodyFormData.append('product_needed', $('#product_needed_'+id).val());
                    //console.log('bodyFormData->',bodyFormData);

                    axios({
                        method: "post",
                        url: "/api/humana/upload_update/"+id,
                        data: bodyFormData,
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then(function (response) {
                        //handle success
                        //console.log(response);
                        window.location.reload();
                    });
                 } else {
                    $('#'+form)[0].reportValidity()
                 }


            });

            window.setTimeout(() => this._syncInReviewSubToggle(inReviewToggle), 1250);
        },

        /**
         * That little button toggle issue bugs me. That is, if they previously selected one other than the first, it'll highlight what they selected previously and also the first toggle button.
         * This syncs the button toggle with what's actually being displayed.
         * A bit hacky, but it works.
         *
         * @param inReviewToggle
         * @private
         */
        _syncInReviewSubToggle(inReviewToggle) {
            window.setTimeout(() => {
                const visibleReviewTableClass = String(
                    Array.from(
                        $('#rfp_in_review .in_review_table:not(.hide)').get(0).classList
                    ).filter(className => className !== 'in_review_table' && className.endsWith('_table')) [0]
                );
                const toggleInputValue = visibleReviewTableClass.substring(0, visibleReviewTableClass.lastIndexOf('_table'));

                inReviewToggle.find('.btn').removeClass('active');
                inReviewToggle.find(`input[value=${toggleInputValue}]`).closest('.btn').addClass('active');
            }, 2000);
        },
    },

    ncm: {

        importTimer: null,
        importComplete: [],

        init: function() {
            const _this = this;
            const ncmToggle = $('.bhoechie-tab-content:has(#ncm_tables) .btn-group-toggle');
            ncmToggle.on('click', event => {
                $(`.bhoechie-tab-content:has(#ncm_tables) .ncm_table`).hide();
                $(`.bhoechie-tab-content:has(#ncm_tables) .${event.target.value}_table`).show();
            });

            $("#app_data_tables_new_customer_matching_events_data_table").on('draw.dt', function () {
                _this.importCheck();
            });
        },

        importCheck: function() {
            const _this = this;
            const files = $("#app_data_tables_new_customer_matching_events_data_table .import_status");

            clearTimeout(_this.importTimer);
            _this.importComplete = [];

            // First check if the table is loaded, if not check back every 2 seconds
            if (!files[0]) {
                setTimeout(function() {
                    _this.importCheck();
                }, 2000);
            } else {
                // Loop through files to populate map
                files.each(function() {
                    _this.importStatus($(this).data("id"));
                });
            }
        },

        importStatus: function(eventID) {
            const _this = this;

            if (_this.importComplete.includes(eventID)) {
                return;
            }

            axios.get('/api/new_customer_matching/import_items/'+eventID+'/status').then(function (response) {
                let status = '';
                let complete = false;
                let completed = parseInt(response.data.completed, 10);
                let total = parseInt(response.data.total, 10);
                const tableRow = $('#app_data_tables_new_customer_matching_events_data_table .import_status[data-id="'+eventID+'"]').closest('tr');

                if (total < 1) {
                    status = 'Initializing...';
                } else if (completed < total) {
                    status = response.data.completed + ' out of ' +response.data.total + ' items completed.';
                } else {
                    status = 'Matching completed for all ' + response.data.total + ' items.';
                    complete = true;

                    if (!_this.importComplete.includes(eventID)) {
                        _this.importComplete.push(eventID);
                    }
                }

                tableRow.find('.items_progress .message').html(status);

                if (complete) {
                    tableRow.find('.items_progress').removeClass('alert-primary').addClass('alert-info');
                    tableRow.find('.items_progress .spinner').hide();
                    tableRow.find('.btn-export, .btn-award-file').removeClass('disabled');
                } else {
                    _this.importCheckTimer = setTimeout(function() {
                        abcsetup.dashboard.strategic_account.ncm.importStatus(eventID);
                    }, 15000);
                }
            });
        },
    },

    /**
     *
     */
    delete: function(id,_this) {
        $('#item_spreadsheets').find('.dataTables_wrapper').hide();
        abcsetup.blockUI(true);
        axios.delete('/api/humana/' + id).then(response => {
            abcsetup.unblockUI();
                _this.closest('tr').fadeOut('slow', function() {
                    $(this).remove();
            });
        });
    },
}
